import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from '@obo-main/services/modal/modal.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { throwError } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ChatService } from '@obo-main/components/chatBot/services/chat.service';
import { NgForOf } from '@angular/common';
import { MessageComponent } from '@obo-main/components/chatBot/components/message/message.component';
import { AlertService } from '@obo-main/services/common/alert/alert.service';
import { LoadingAnimationComponent } from '@obo-main/components/chatBot/components/loading-animation/loading-animation.component';
import { TranslateService } from '@ngx-translate/core';
import { ExampleQuestionsComponent } from '@obo-main/components/chatBot/components/example-questions/example-questions.component';
import { MarkdownService } from 'ngx-markdown';

@Component({
    selector: 'app-chat-bot',
    standalone: true,
    imports: [FaIconComponent, FormsModule, NgForOf, MessageComponent, LoadingAnimationComponent, ExampleQuestionsComponent],
    templateUrl: './chat-bot.component.html',
    styleUrl: './chat-bot.component.scss',
    exportAs: 'chatBot'
})
export class ChatBotComponent {
    @Output()
    public confirmed = new EventEmitter<void>();
    @Output()
    public dismissed = new EventEmitter<void>();

    @Input()
    public title: string;

    @ViewChild('chatBot') modal: TemplateRef<any>;
    @ViewChild('chatbotBody') chatbotBody: ElementRef;

    public textInput: string;
    public displayLoadingAnim = false;

    constructor(
        private modalService: ModalService,
        public chatService: ChatService,
        private viewContainerRef: ViewContainerRef,
        private alertService: AlertService,
        private translate: TranslateService,
        private markdownService: MarkdownService
    ) {}

    public show(): void {
        /*
         * config and language are set in the ufs configuratorResolver
         * if the configurator is not set, the chatbot is not available for this page
         */
        if (
            this.chatService.configurator &&
            this.chatService.language &&
            window.location.pathname.includes(this.chatService.configurator)
        ) {
            this.modalService.open(this.modal, { viewContainerRef: this.viewContainerRef }).result.then(
                (result) => this.confirmed.emit(),
                (reason) => this.dismissed.emit()
            );
            this.chatService.getConversation().subscribe({});
        } else {
            this.alertService.info(this.translate.instant('CHATBOT_NOT_AVAILABLE_FOR_PAGE'));
        }
    }

    sendMessage() {
        if (this.textInput === '') {
            return;
        }
        this.displayLoadingAnim = true;
        this.chatService.answerQuestion(this.textInput, this.chatbotBody).subscribe({
            next: (response) => {
                this.displayLoadingAnim = false;
                this.chatService.addPartialAssistantMessage(response);
            },
            error: (error) => {
                this.displayLoadingAnim = false;
                return throwError(() => new Error('Failed to send message'));
            },
            complete: () => {}
        });

        this.textInput = '';
    }

    newConversation() {
        this.chatService.newConversation().subscribe({
            next: (response) => {
                this.chatService.getConversation().subscribe({
                    next: (response) => {},
                    error: (error) => {
                        return throwError(() => new Error('Failed to get conversation'));
                    }
                });
            },
            error: (error) => {
                return throwError(() => new Error('Failed to create new conversation'));
            }
        });
    }

    protected sendExampleMessage($event: string) {
        this.textInput = $event;
        this.sendMessage();
    }
}
